import { Container, Stack } from '@mantine/core';
import PageTitle from 'components/PageTitle';
import PAGES from 'constant/pages';
import { useAppName } from 'contexts/AppProvider';
import CreateMasterPlanForm from 'modules/pages/dacum/reviewMasterplan/CreateMasterPlanForm';
import React from 'react';

const CreateMasterPlanPage = () => {
  const { appName } = useAppName();
  const pageContent = PAGES[appName]?.reviewMasterPlan;

  return (
    <Container fluid>
      <Stack>
        <PageTitle title={'Create Master Plan'} description={pageContent?.description || ''} />
        <CreateMasterPlanForm />
      </Stack>
    </Container>
  );
};

export default CreateMasterPlanPage;
